"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFormattedOffset = exports.getDefaultAssetSpec = exports.toLowerCasePropertyNames = exports.isIFramed = exports.wait = void 0;
const Versioning_1 = __importDefault(require("../versioning/Versioning"));
function wait(waitTimeMs) {
    return new Promise(resolve => setTimeout(resolve, waitTimeMs));
}
exports.wait = wait;
// This is impossible to adequately test in Node, so Istanbul ignore.
/* istanbul ignore next */
function isIFramed() {
    var _a;
    // Same-origin iframes can check `nodeName`.
    // We can also check whether the parent window and the top window are the same.
    // Cross-origin iframes will throw on the `parent` check, so catch here.
    try {
        return ((_a = window.frameElement) === null || _a === void 0 ? void 0 : _a.nodeName) === 'IFRAME' || parent !== top;
    }
    catch (e) {
        // Very likely to be a cross-origin iframe.
        return true;
    }
}
exports.isIFramed = isIFramed;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function toLowerCasePropertyNames(input) {
    if (input === null) {
        return null;
    }
    else if (typeof input !== 'object') {
        return input;
    }
    else if (Array.isArray(input)) {
        return input.map(toLowerCasePropertyNames);
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return Object.keys(input).reduce((result, key) => {
        const value = input[key];
        const newValue = typeof value === 'object' ? toLowerCasePropertyNames(value) : value;
        result[key.toLowerCase()] = newValue;
        return result;
    }, {});
}
exports.toLowerCasePropertyNames = toLowerCasePropertyNames;
/**
 * Based on the SDK version, return an asset group.
 *
 * @returns the default asset spec, based on the SDK version.
 */
function getDefaultAssetSpec() {
    const version = Versioning_1.default.sdkVersionSemVer;
    return {
        assetGroup: `sdk-${version.major}.${version.minor}`,
    };
}
exports.getDefaultAssetSpec = getDefaultAssetSpec;
/**
 * Get UTC offset in (+|-)HH:mm format
 * E.g. For Asia/Calcutta timezone, +05:30 UTC offset value is returned
 */
function getFormattedOffset(utcOffset) {
    const offset = Math.abs(utcOffset);
    const offsetOperator = utcOffset <= 0 ? '+' : '-';
    const offsetHours = Math.floor(offset / 60)
        .toString()
        .padStart(2, '0');
    const offsetMinutes = Math.floor(offset % 60)
        .toString()
        .padStart(2, '0');
    return `${offsetOperator}${offsetHours}:${offsetMinutes}`;
}
exports.getFormattedOffset = getFormattedOffset;
//# sourceMappingURL=Utils.js.map